const menu = {
  banner: {
    owner: 'main_banner',
    title: 'Website',
    list: [
      {
        label: 'Main Banner',
        icon: `<svg viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg" class="w-5 h-5">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M4 3.55591C2.89543 3.55591 2 4.45134 2 5.55591V15.5559C2 16.6605 2.89543 17.5559 4 17.5559H16C17.1046 17.5559 18 16.6605 18 15.5559V5.55591C18 4.45134 17.1046 3.55591 16 3.55591H4ZM16 15.5559H4L8 7.55591L11 13.5559L13 9.55591L16 15.5559Z" fill="currentColor"/>
        </svg>
        `,
        target: 'admin-main-banner',
        type: 'route',
      },
      // {
      //   label: 'Running Text',
      //   icon: `<svg class="w-5 h-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
      //   <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 12c0-1.232-.046-2.453-.138-3.662a4.006 4.006 0 0 0-3.7-3.7 48.678 48.678 0 0 0-7.324 0 4.006 4.006 0 0 0-3.7 3.7c-.017.22-.032.441-.046.662M19.5 12l3-3m-3 3-3-3m-12 3c0 1.232.046 2.453.138 3.662a4.006 4.006 0 0 0 3.7 3.7 48.656 48.656 0 0 0 7.324 0 4.006 4.006 0 0 0 3.7-3.7c.017-.22.032-.441.046-.662M4.5 12l3 3m-3-3-3 3" />
      //   </svg>
      //   `,
      //   target: 'admin-running-text',
      //   type: 'route',
      // },
      // {
      //   label: 'Create Banner',
      //   icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-5 h-5">
      //       <path fill-rule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25ZM12.75 9a.75.75 0 0 0-1.5 0v2.25H9a.75.75 0 0 0 0 1.5h2.25V15a.75.75 0 0 0 1.5 0v-2.25H15a.75.75 0 0 0 0-1.5h-2.25V9Z" clip-rule="evenodd" />
      //     </svg>
      //     `,
      //   target: 'admin-main-banner-form',
      //   type: 'route',
      // },
    ],
  },
  blog: {
    owner: 'articles',
    title: 'News & Information',
    list: [
      {
        label: 'Article List',
        icon: `<svg viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg" class="w-5 h-5">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M5 4.55591C3.34315 4.55591 2 5.89905 2 7.55591V13.5559C2 15.2128 3.34315 16.5559 5 16.5559H15C16.6569 16.5559 18 15.2128 18 13.5559V7.55591C18 5.89905 16.6569 4.55591 15 4.55591H5ZM4 13.5559V12.5559H9V14.5559H5C4.44772 14.5559 4 14.1082 4 13.5559ZM11 14.5559H15C15.5523 14.5559 16 14.1082 16 13.5559V12.5559H11V14.5559ZM11 10.5559H16V8.55591H11V10.5559ZM9 8.55591H4V10.5559H9V8.55591Z" fill="currentColor"/>
        </svg>
          `,
        target: 'admin-articles',
        type: 'route',
      },
      // {
      //   label: 'Meta Seo',
      //   icon: `<svg class="w-4 h-4" viewBox="0 0 16 11" fill="none" xmlns="http://www.w3.org/2000/svg">
      //     <path fill-rule="evenodd" clip-rule="evenodd" d="M10 2.55591C9.44771 2.55591 9 2.10819 9 1.55591C9 1.00362 9.44771 0.555908 10 0.555908H15C15.5523 0.555908 16 1.00362 16 1.55591V6.55591C16 7.10819 15.5523 7.55591 15 7.55591C14.4477 7.55591 14 7.10819 14 6.55591V3.97012L9.70711 8.26301C9.31658 8.65354 8.68342 8.65354 8.29289 8.26301L6 5.97012L1.70711 10.263C1.31658 10.6535 0.683417 10.6535 0.292893 10.263C-0.0976311 9.87249 -0.0976311 9.23933 0.292893 8.8488L5.29289 3.8488C5.68342 3.45828 6.31658 3.45828 6.70711 3.8488L9 6.1417L12.5858 2.55591H10Z" fill="currentColor"/>
      //   </svg>        
      //     `,
      //   target: null,
      //   type: 'route',
      //   locked: true,
      // },
      // {
      //   label: 'Categories',
      //   icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-5 h-5">
      //       <path fill-rule="evenodd" d="M2.625 6.75a1.125 1.125 0 1 1 2.25 0 1.125 1.125 0 0 1-2.25 0Zm4.875 0A.75.75 0 0 1 8.25 6h12a.75.75 0 0 1 0 1.5h-12a.75.75 0 0 1-.75-.75ZM2.625 12a1.125 1.125 0 1 1 2.25 0 1.125 1.125 0 0 1-2.25 0ZM7.5 12a.75.75 0 0 1 .75-.75h12a.75.75 0 0 1 0 1.5h-12A.75.75 0 0 1 7.5 12Zm-4.875 5.25a1.125 1.125 0 1 1 2.25 0 1.125 1.125 0 0 1-2.25 0Zm4.875 0a.75.75 0 0 1 .75-.75h12a.75.75 0 0 1 0 1.5h-12a.75.75 0 0 1-.75-.75Z" clip-rule="evenodd" />
      //     </svg>
      //     `,
      //   target: null,
      //   type: 'route',
      // },
    ],
  },
  // faq: {
  //   owner: 'faq',
  //   title: 'Frequently Asked Questions',
  //   list: [
  //     {
  //       label: 'Topics',
  //       icon: `<svg viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg" class="w-5 h-5">
  //         <path d="M2 5.55591C2 4.45134 2.89543 3.55591 4 3.55591H11C12.1046 3.55591 13 4.45134 13 5.55591V9.55591C13 10.6605 12.1046 11.5559 11 11.5559H9L6 14.5559V11.5559H4C2.89543 11.5559 2 10.6605 2 9.55591V5.55591Z" fill="currentColor"/>
  //         <path d="M15 7.55591V9.55591C15 11.765 13.2091 13.5559 11 13.5559H9.82843L8.06173 15.3226C8.34154 15.4715 8.66091 15.5559 9 15.5559H11L14 18.5559V15.5559H16C17.1046 15.5559 18 14.6605 18 13.5559V9.55591C18 8.45134 17.1046 7.55591 16 7.55591H15Z" fill="currentColor"/>
  //         </svg>
  //         `,
  //       target: 'admin-faq-topic',
  //       type: 'route',
  //     },
  //     {
  //       label: 'FAQ',
  //       icon: `<svg viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg" class="w-5 h-5">
  //         <path d="M2 5.55591C2 4.45134 2.89543 3.55591 4 3.55591H11C12.1046 3.55591 13 4.45134 13 5.55591V9.55591C13 10.6605 12.1046 11.5559 11 11.5559H9L6 14.5559V11.5559H4C2.89543 11.5559 2 10.6605 2 9.55591V5.55591Z" fill="currentColor"/>
  //         <path d="M15 7.55591V9.55591C15 11.765 13.2091 13.5559 11 13.5559H9.82843L8.06173 15.3226C8.34154 15.4715 8.66091 15.5559 9 15.5559H11L14 18.5559V15.5559H16C17.1046 15.5559 18 14.6605 18 13.5559V9.55591C18 8.45134 17.1046 7.55591 16 7.55591H15Z" fill="currentColor"/>
  //         </svg>
  //         `,
  //       target: 'admin-faq',
  //       type: 'route',
  //     },
  //     // {
  //     //   label: 'Create Question',
  //     //   icon: `<svg viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg" class="w-5 h-5">
  //     //     <path d="M2 5.55591C2 4.45134 2.89543 3.55591 4 3.55591H11C12.1046 3.55591 13 4.45134 13 5.55591V9.55591C13 10.6605 12.1046 11.5559 11 11.5559H9L6 14.5559V11.5559H4C2.89543 11.5559 2 10.6605 2 9.55591V5.55591Z" fill="currentColor"/>
  //     //     <path d="M15 7.55591V9.55591C15 11.765 13.2091 13.5559 11 13.5559H9.82843L8.06173 15.3226C8.34154 15.4715 8.66091 15.5559 9 15.5559H11L14 18.5559V15.5559H16C17.1046 15.5559 18 14.6605 18 13.5559V9.55591C18 8.45134 17.1046 7.55591 16 7.55591H15Z" fill="currentColor"/>
  //     //     </svg>
  //     //     `,
  //     //   target: 'admin-faq-form',
  //     //   type: 'route',
  //     // },
  //   ],
  // },
  // customer_service: {
  //   title: 'Customer Service',
  //   list: [
  //     {
  //       label: 'Gen AI Chatbot',
  //       icon: `<svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg" class="w-5 h-5">
  //         <path fill-rule="evenodd" clip-rule="evenodd" d="M18 10.5559C18 14.4219 14.4183 17.5559 10 17.5559C8.50836 17.5559 7.11208 17.1987 5.91677 16.5767L2 17.5559L3.3383 14.4332C2.4928 13.3232 2 11.9899 2 10.5559C2 6.68991 5.58172 3.55591 10 3.55591C14.4183 3.55591 18 6.68991 18 10.5559ZM7 9.55591H5V11.5559H7V9.55591ZM15 9.55591H13V11.5559H15V9.55591ZM9 9.55591H11V11.5559H9V9.55591Z" fill="currentColor"/>
  //       </svg>        
  //         `,
  //       target: null,
  //       type: 'route',
  //       locked: true,
  //     },
  //   ],
  // },
  account: {
    title: 'Account',
    list: [
      {
        label: 'Manage User',
        icon: `<svg class="w-5 h-5" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M13 6.98633C13 8.64318 11.6569 9.98633 10 9.98633C8.34315 9.98633 7 8.64318 7 6.98633C7 5.32947 8.34315 3.98633 10 3.98633C11.6569 3.98633 13 5.32947 13 6.98633Z" fill="currentColor"/>
        <path d="M18 8.98633C18 10.0909 17.1046 10.9863 16 10.9863C14.8954 10.9863 14 10.0909 14 8.98633C14 7.88176 14.8954 6.98633 16 6.98633C17.1046 6.98633 18 7.88176 18 8.98633Z" fill="currentColor"/>
        <path d="M14 15.9863C14 13.7772 12.2091 11.9863 10 11.9863C7.79086 11.9863 6 13.7772 6 15.9863V18.9863H14V15.9863Z" fill="currentColor"/>
        <path d="M6 8.98633C6 10.0909 5.10457 10.9863 4 10.9863C2.89543 10.9863 2 10.0909 2 8.98633C2 7.88176 2.89543 6.98633 4 6.98633C5.10457 6.98633 6 7.88176 6 8.98633Z" fill="currentColor"/>
        <path d="M16 18.9863V15.9863C16 14.9322 15.7282 13.9415 15.2507 13.0807C15.4902 13.0191 15.7413 12.9863 16 12.9863C17.6569 12.9863 19 14.3295 19 15.9863V18.9863H16Z" fill="currentColor"/>
        <path d="M4.74926 13.0807C4.27185 13.9415 4 14.9322 4 15.9863V18.9863H1V15.9863C1 14.3295 2.34315 12.9863 4 12.9863C4.25871 12.9863 4.50977 13.0191 4.74926 13.0807Z" fill="currentColor"/>
        </svg>
        `,
        target: 'admin-manage-user',
        type: 'route',
        super_user: true,
      },
      {
        label: 'Manage Roles',
        icon: `<svg class="w-5 h-5" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9 2.98633C8.44772 2.98633 8 3.43404 8 3.98633C8 4.53861 8.44772 4.98633 9 4.98633H11C11.5523 4.98633 12 4.53861 12 3.98633C12 3.43404 11.5523 2.98633 11 2.98633H9Z" fill="currentColor"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M4 5.98633C4 4.88176 4.89543 3.98633 6 3.98633C6 5.64318 7.34315 6.98633 9 6.98633H11C12.6569 6.98633 14 5.64318 14 3.98633C15.1046 3.98633 16 4.88176 16 5.98633V16.9863C16 18.0909 15.1046 18.9863 14 18.9863H6C4.89543 18.9863 4 18.0909 4 16.9863V5.98633ZM7 9.98633C6.44772 9.98633 6 10.434 6 10.9863C6 11.5386 6.44772 11.9863 7 11.9863H7.01C7.56228 11.9863 8.01 11.5386 8.01 10.9863C8.01 10.434 7.56228 9.98633 7.01 9.98633H7ZM10 9.98633C9.44772 9.98633 9 10.434 9 10.9863C9 11.5386 9.44772 11.9863 10 11.9863H13C13.5523 11.9863 14 11.5386 14 10.9863C14 10.434 13.5523 9.98633 13 9.98633H10ZM7 13.9863C6.44772 13.9863 6 14.434 6 14.9863C6 15.5386 6.44772 15.9863 7 15.9863H7.01C7.56228 15.9863 8.01 15.5386 8.01 14.9863C8.01 14.434 7.56228 13.9863 7.01 13.9863H7ZM10 13.9863C9.44772 13.9863 9 14.434 9 14.9863C9 15.5386 9.44772 15.9863 10 15.9863H13C13.5523 15.9863 14 15.5386 14 14.9863C14 14.434 13.5523 13.9863 13 13.9863H10Z" fill="currentColor"/>
        </svg>
        `,
        target: 'admin-manage-roles',
        type: 'route',
        super_user: true,
      },
      {
        label: 'Manage Profile',
        icon: `<svg class="w-5 h-5" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M10 9.98633C11.6569 9.98633 13 8.64318 13 6.98633C13 5.32947 11.6569 3.98633 10 3.98633C8.34315 3.98633 7 5.32947 7 6.98633C7 8.64318 8.34315 9.98633 10 9.98633Z" fill="currentColor"/>
          <path d="M3 18.9863C3 15.1203 6.13401 11.9863 10 11.9863C13.866 11.9863 17 15.1203 17 18.9863H3Z" fill="currentColor"/>
          </svg>
        `,
        target: 'admin-manage-profile',
        type: 'route',
      },
    ],
  },
  // settings: {
  //   title: 'Settings',
  //   list: [
  //     {
  //       label: 'General Settings',
  //       icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-5 h-5">
  //           <path fill-rule="evenodd" d="M11.078 2.25c-.917 0-1.699.663-1.85 1.567L9.05 4.889c-.02.12-.115.26-.297.348a7.493 7.493 0 0 0-.986.57c-.166.115-.334.126-.45.083L6.3 5.508a1.875 1.875 0 0 0-2.282.819l-.922 1.597a1.875 1.875 0 0 0 .432 2.385l.84.692c.095.078.17.229.154.43a7.598 7.598 0 0 0 0 1.139c.015.2-.059.352-.153.43l-.841.692a1.875 1.875 0 0 0-.432 2.385l.922 1.597a1.875 1.875 0 0 0 2.282.818l1.019-.382c.115-.043.283-.031.45.082.312.214.641.405.985.57.182.088.277.228.297.35l.178 1.071c.151.904.933 1.567 1.85 1.567h1.844c.916 0 1.699-.663 1.85-1.567l.178-1.072c.02-.12.114-.26.297-.349.344-.165.673-.356.985-.57.167-.114.335-.125.45-.082l1.02.382a1.875 1.875 0 0 0 2.28-.819l.923-1.597a1.875 1.875 0 0 0-.432-2.385l-.84-.692c-.095-.078-.17-.229-.154-.43a7.614 7.614 0 0 0 0-1.139c-.016-.2.059-.352.153-.43l.84-.692c.708-.582.891-1.59.433-2.385l-.922-1.597a1.875 1.875 0 0 0-2.282-.818l-1.02.382c-.114.043-.282.031-.449-.083a7.49 7.49 0 0 0-.985-.57c-.183-.087-.277-.227-.297-.348l-.179-1.072a1.875 1.875 0 0 0-1.85-1.567h-1.843ZM12 15.75a3.75 3.75 0 1 0 0-7.5 3.75 3.75 0 0 0 0 7.5Z" clip-rule="evenodd" />
  //         </svg>
  //         `,
  //       target: null,
  //       type: 'route',
  //     },
  //     {
  //       label: 'Users',
  //       icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-5 h-5">
  //           <path d="M4.5 6.375a4.125 4.125 0 1 1 8.25 0 4.125 4.125 0 0 1-8.25 0ZM14.25 8.625a3.375 3.375 0 1 1 6.75 0 3.375 3.375 0 0 1-6.75 0ZM1.5 19.125a7.125 7.125 0 0 1 14.25 0v.003l-.001.119a.75.75 0 0 1-.363.63 13.067 13.067 0 0 1-6.761 1.873c-2.472 0-4.786-.684-6.76-1.873a.75.75 0 0 1-.364-.63l-.001-.122ZM17.25 19.128l-.001.144a2.25 2.25 0 0 1-.233.96 10.088 10.088 0 0 0 5.06-1.01.75.75 0 0 0 .42-.643 4.875 4.875 0 0 0-6.957-4.611 8.586 8.586 0 0 1 1.71 5.157v.003Z" />
  //         </svg>
  //         `,
  //       target: null,
  //       type: 'route',
  //     },
  //     {
  //       label: 'Role',
  //       icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-5 h-5">
  //       <path fill-rule="evenodd" d="M11.484 2.17a.75.75 0 0 1 1.032 0 11.209 11.209 0 0 0 7.877 3.08.75.75 0 0 1 .722.515 12.74 12.74 0 0 1 .635 3.985c0 5.942-4.064 10.933-9.563 12.348a.749.749 0 0 1-.374 0C6.314 20.683 2.25 15.692 2.25 9.75c0-1.39.223-2.73.635-3.985a.75.75 0 0 1 .722-.516l.143.001c2.996 0 5.718-1.17 7.734-3.08ZM12 8.25a.75.75 0 0 1 .75.75v3.75a.75.75 0 0 1-1.5 0V9a.75.75 0 0 1 .75-.75ZM12 15a.75.75 0 0 0-.75.75v.008c0 .414.336.75.75.75h.008a.75.75 0 0 0 .75-.75v-.008a.75.75 0 0 0-.75-.75H12Z" clip-rule="evenodd" />
  //     </svg>

  //         `,
  //       target: null,
  //       type: 'route',
  //     },
  //   ],
  // },
};

export default menu;
